import * as yup from "yup";

export const UsersValidation = yup.object().shape({
    name: yup
        .string()
        .required("Full name is required")
        .min(2, "Full name must be at least 2 characters")
        .max(100, "Full name must not exceed 100 characters")
        .matches(/^[a-zA-Z\s]+$/, "Full name can only contain letters and spaces")
        .trim(),

    email: yup
        .string()
        .required("Email address is required")
        .email("Please enter a valid email address")
        .max(255, "Email address must not exceed 255 characters")
        .trim(),

    mobile: yup
        .string()
        .required("Mobile number is required")
        .matches(/^[0-9+\-\s()]+$/, "Mobile number can only contain numbers, spaces, hyphens, and parentheses")
        .min(10, "Mobile number must be at least 10 digits")
        .max(15, "Mobile number must not exceed 15 digits")
        .trim(),

    role: yup
        .string()
        .required("Role is required")
        .test("valid-role", "Please select a valid role", function (value) {
            // Allow any role value - validation will be handled by the component
            return value && value.length > 0;
        }),

    password: yup.string().when("$formType", {
        is: "Add",
        then: (schema) =>
            schema
                .required("Password is required")
                .min(8, "Password must be at least 8 characters")
                .max(50, "Password must not exceed 50 characters")
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
                    "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
                ),
        otherwise: (schema) =>
            schema
                .nullable()
                .optional()
                .when("password", {
                    is: (value) => value && value.length > 0,
                    then: (schema) =>
                        schema
                            .min(8, "Password must be at least 8 characters")
                            .max(50, "Password must not exceed 50 characters")
                            .matches(
                                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
                                "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
                            ),
                    otherwise: (schema) => schema,
                }),
    }),

    parent_id: yup.string().nullable().optional(),

    region_id: yup
        .string()
        .nullable()
        .optional()
        .test("region-required", "Region is required", function (value) {
            // Region is optional for now, but can be made required if needed
            return true;
        }),

    dob: yup
        .date()
        .nullable()
        .optional()
        .max(new Date(), "Date of birth cannot be in the future")
        .test("age-validation", "Age must be between 18 and 100 years", function (value) {
            if (!value) return true; // Optional field
            const today = new Date();
            const birthDate = new Date(value);
            const age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                return age - 1 >= 18 && age - 1 <= 100;
            }
            return age >= 18 && age <= 100;
        }),

    full_address: yup.string().nullable().optional().max(1000, "Address must not exceed 1000 characters").trim(),

    aadhar_number: yup
        .string()
        .nullable()
        .optional()
        .matches(/^\d{12}$/, "Aadhar number must be exactly 12 digits")
        .test("aadhar-format", "Aadhar number must contain only numbers", function (value) {
            if (!value) return true; // Optional field
            return /^\d{12}$/.test(value);
        })
        .trim(),

    is_active: yup.boolean().default(true),
});
